import { Drawer } from '@/components';
import { useAccountingTypes } from '@/features/master-table/hooks';
import { useProject } from '@/features/project/_hooks/project';
import { useUpdateExecutionProgressIncomeAndExpenditureSummary } from '@/features/project/projects/detail/execution-progress/_hooks/execution-progress';
import { useId } from '@/hooks';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectDetailDrawerState } from '../../_components/ProjectDrawerStateProvider';
import { UpdateExecutionProgressIncomeAndExpenditureSummaryForm } from './UpdateExecutionProgressIncomeAndExpenditureSummaryForm';

export const UpdateExecutionProgressIncomeAndExpenditureSummaryFormDrawer: FC =
  () => {
    const { t } = useTranslation();
    const accountingTypes = useAccountingTypes();
    const { openMessage } = useMessage();
    const { id: projectId } = useId();
    const project = useProject(projectId);
    const { drawerState, setDrawerState } = useProjectDetailDrawerState();
    const { mutateAsync: updateExecutionProgressIncomeAndExpenditureSummary } =
      useUpdateExecutionProgressIncomeAndExpenditureSummary();

    if (!project.data) {
      return null;
    }

    const { fiscalYear, fundAdditionalAttributes } = project.data;

    const handleClose = async () => {
      setDrawerState({ open: false });
    };

    return (
      <Drawer
        destroyOnClose
        open={
          drawerState.open &&
          drawerState.type ===
            'execution-progress-income-and-expenditure-summary'
        }
        onClose={handleClose}
      >
        <UpdateExecutionProgressIncomeAndExpenditureSummaryForm
          endOfYear={fiscalYear - 1}
          initialValues={
            fundAdditionalAttributes
              ? {
                  accountingTypeIds: fundAdditionalAttributes.accountingTypeIds,
                  numberOfLocalFundBuilding:
                    fundAdditionalAttributes.numberOfLocalFundBuilding,
                }
              : undefined
          }
          accountingTypeOptions={accountingTypes.data?.map(
            (accountingType) => ({
              value: accountingType.id,
              label: accountingType.name,
            }),
          )}
          onSubmit={async (values) => {
            try {
              await updateExecutionProgressIncomeAndExpenditureSummary({
                ...values,
                projectId,
              });

              await Promise.all([
                openMessage('success', t('message-update-completed')),
                handleClose(),
              ]);
            } catch {
              await openMessage('error', t('message-update-failed'));
            }
          }}
        />
      </Drawer>
    );
  };
